<!-- Start Page Title Area -->
<div class="page-title-area">
    <div class="container">
        <div class="page-title-content">

            <h2>Terms & Conditions</h2>

            <ul>
                <li>
                    <a routerLink="/">Home</a>
                </li>

                <li>Terms & Conditions</li>
            </ul>

        </div>
    </div>
</div>
<!-- End Page Title Area -->


<!-- Start Terms & Conditions Area -->
<section class="terms-conditions-area ptb-100">
    <div class="container">

        <div class="terms-content">

            <!-- Introduction -->
            <div class="terms-intro">

                <span>SolarCiti Terms & Conditions</span>

                <h2>
                    Terms for Using Our Website & Services
                </h2>

                <p>
                    Welcome to SolarCiti. These Terms & Conditions
                    ("Terms", "Terms & Conditions") govern your access
                    to and use of the SolarCiti website and the services
                    provided through it.
                </p>

                <p>
                    By accessing, browsing, or using this website, you
                    acknowledge that you have read, understood, and agree
                    to comply with these Terms & Conditions. If you do not
                    agree with any part of these Terms, please do not use
                    the website or its services.
                </p>

            </div>


            <!-- 01 -->
            <div class="terms-item">

                <h3>
                    <span>01</span>
                    About SolarCiti
                </h3>

                <p>
                    SolarCiti provides solar energy solutions and related
                    services for residential, commercial, and other suitable
                    applications.
                </p>

                <p>
                    Our website provides information about solar systems,
                    installation services, system types, solar savings,
                    financing options where available, and other
                    solar-related solutions.
                </p>

            </div>


            <!-- 02 -->
            <div class="terms-item">

                <h3>
                    <span>02</span>
                    Use of Our Website
                </h3>

                <p>
                    You agree to use the SolarCiti website only for lawful
                    purposes and in a manner that does not interfere with
                    the operation, security, or availability of the website.
                </p>

                <ul>
                    <li>
                        <i class="bx bx-check"></i>
                        Use the website for legitimate purposes only
                    </li>

                    <li>
                        <i class="bx bx-check"></i>
                        Provide accurate information when submitting enquiries
                    </li>

                    <li>
                        <i class="bx bx-check"></i>
                        Do not attempt to gain unauthorized access to the website
                    </li>

                    <li>
                        <i class="bx bx-check"></i>
                        Do not introduce malicious software or harmful content
                    </li>

                    <li>
                        <i class="bx bx-check"></i>
                        Do not misuse or reproduce website content without permission
                    </li>
                </ul>

            </div>


            <!-- 03 -->
            <div class="terms-item">

                <h3>
                    <span>03</span>
                    Solar Information & Estimates
                </h3>

                <p>
                    Information provided on the SolarCiti website is intended
                    to provide general information about solar energy,
                    products, systems, and related services.
                </p>

                <p>
                    Solar calculations, savings estimates, system sizing
                    information, generation estimates, and other figures
                    displayed through the website may vary depending on
                    actual site conditions, electricity consumption,
                    location, equipment, installation conditions, tariffs,
                    applicable regulations, and other factors.
                </p>

                <p>
                    Website estimates should therefore be considered
                    indicative and should not be treated as a guaranteed
                    result or final technical proposal.
                </p>

            </div>


            <!-- 04 -->
            <div class="terms-item">

                <h3>
                    <span>04</span>
                    Solar Consultation & Site Assessment
                </h3>

                <p>
                    Any consultation, quotation, recommendation, or system
                    proposal provided by SolarCiti may be subject to further
                    assessment of the property, electricity requirements,
                    available installation area, structural conditions,
                    electrical requirements, and other relevant factors.
                </p>

                <p>
                    A final system design, equipment selection, pricing,
                    installation scope, and project timeline may differ
                    from preliminary information provided through the
                    website.
                </p>

            </div>


            <!-- 05 -->
            <div class="terms-item">

                <h3>
                    <span>05</span>
                    Quotations & Pricing
                </h3>

                <p>
                    Any prices, quotations, offers, or estimates displayed
                    or communicated by SolarCiti are subject to the applicable
                    scope of work and project requirements.
                </p>

                <p>
                    Prices may vary based on system capacity, equipment
                    selection, installation requirements, site conditions,
                    applicable taxes, government policies, subsidies,
                    approvals, and other project-related factors.
                </p>

                <p>
                    A quotation does not constitute a final agreement unless
                    accepted by the customer and confirmed by SolarCiti
                    through the applicable process.
                </p>

            </div>


            <!-- 06 -->
            <div class="terms-item">

                <h3>
                    <span>06</span>
                    Solar Subsidy & Government Schemes
                </h3>

                <p>
                    SolarCiti may provide information or documentation
                    assistance regarding applicable government schemes,
                    subsidies, approvals, or related processes where such
                    services are offered.
                </p>

                <p>
                    Eligibility, subsidy amount, approval, processing time,
                    documentation requirements, and availability of any
                    government scheme are determined by the relevant
                    government authority and applicable regulations.
                </p>

                <p>
                    SolarCiti does not guarantee approval or payment of any
                    subsidy unless expressly agreed otherwise in writing.
                </p>

            </div>


            <!-- 07 -->
            <div class="terms-item">

                <h3>
                    <span>07</span>
                    Installation & Project Execution
                </h3>

                <p>
                    Solar installation work will be carried out according
                    to the agreed project scope and applicable technical
                    requirements.
                </p>

                <ul>
                    <li>
                        <i class="bx bx-check"></i>
                        Installation may depend on site readiness
                    </li>

                    <li>
                        <i class="bx bx-check"></i>
                        Electrical and structural requirements may apply
                    </li>

                    <li>
                        <i class="bx bx-check"></i>
                        Project timelines may vary depending on site conditions
                    </li>

                    <li>
                        <i class="bx bx-check"></i>
                        Required approvals or permissions may affect project timelines
                    </li>
                </ul>

            </div>


            <!-- 08 -->
            <div class="terms-item">

                <h3>
                    <span>08</span>
                    Customer Responsibilities
                </h3>

                <p>
                    Customers are responsible for providing accurate and
                    complete information required for evaluating and
                    delivering the requested solar services.
                </p>

                <ul>
                    <li>
                        <i class="bx bx-check"></i>
                        Provide accurate electricity usage information
                    </li>

                    <li>
                        <i class="bx bx-check"></i>
                        Provide access to the installation site where required
                    </li>

                    <li>
                        <i class="bx bx-check"></i>
                        Provide necessary documents and approvals
                    </li>

                    <li>
                        <i class="bx bx-check"></i>
                        Follow applicable safety and operational instructions
                    </li>
                </ul>

            </div>


            <!-- 09 -->
            <div class="terms-item">

                <h3>
                    <span>09</span>
                    Intellectual Property
                </h3>

                <p>
                    Unless otherwise stated, the content available on the
                    SolarCiti website, including text, graphics, logos,
                    images, design elements, and other materials, belongs
                    to or is used by SolarCiti with appropriate rights.
                </p>

                <p>
                    You may not copy, reproduce, modify, distribute,
                    publish, or commercially use website content without
                    prior written permission from SolarCiti.
                </p>

            </div>


            <!-- 10 -->
            <div class="terms-item">

                <h3>
                    <span>10</span>
                    Third-Party Links & Services
                </h3>

                <p>
                    The SolarCiti website may contain links to third-party
                    websites, platforms, payment services, government
                    websites, or other external resources.
                </p>

                <p>
                    SolarCiti does not control or guarantee the availability,
                    accuracy, security, or privacy practices of third-party
                    websites. Your use of such websites is subject to their
                    respective terms and policies.
                </p>

            </div>


            <!-- 11 -->
            <div class="terms-item">

                <h3>
                    <span>11</span>
                    Limitation of Liability
                </h3>

                <p>
                    SolarCiti makes reasonable efforts to keep the information
                    on its website accurate and updated. However, we do not
                    guarantee that all website content will always be complete,
                    current, or error-free.
                </p>

                <p>
                    To the extent permitted by applicable law, SolarCiti
                    shall not be responsible for losses arising solely from
                    reliance on general website information, estimates, or
                    calculations where actual project conditions differ.
                </p>

            </div>


            <!-- 12 -->
            <div class="terms-item">

                <h3>
                    <span>12</span>
                    Website Availability & Security
                </h3>

                <p>
                    We make reasonable efforts to keep the SolarCiti website
                    available and secure. However, we do not guarantee that
                    the website will always be uninterrupted, error-free,
                    or completely free from security threats.
                </p>

                <p>
                    Website availability may be affected by maintenance,
                    technical issues, network failures, or circumstances
                    beyond our reasonable control.
                </p>

            </div>


            <!-- 13 -->
            <div class="terms-item">

                <h3>
                    <span>13</span>
                    Privacy
                </h3>

                <p>
                    Your use of the SolarCiti website may involve the
                    collection and processing of certain information.
                    Please refer to our
                    <a routerLink="/privacy-policy">
                        Privacy Policy
                    </a>
                    for information about how we collect, use, and protect
                    personal information.
                </p>

            </div>


            <!-- 14 -->
            <div class="terms-item">

                <h3>
                    <span>14</span>
                    Changes to These Terms
                </h3>

                <p>
                    SolarCiti may update these Terms & Conditions from time
                    to time to reflect changes in our website, services,
                    business practices, or applicable requirements.
                </p>

                <p>
                    Updated Terms will be published on this page. Your
                    continued use of the website after changes are posted
                    indicates your acceptance of the updated Terms.
                </p>

            </div>


            <!-- 15 -->
            <div class="terms-item">

                <h3>
                    <span>15</span>
                    Governing Law
                </h3>

                <p>
                    These Terms & Conditions and your use of the SolarCiti
                    website shall be governed by the applicable laws of
                    India, subject to the jurisdiction of the appropriate
                    courts in India.
                </p>

            </div>


            <!-- Contact Box -->
            <div class="terms-contact-box">

                <div class="terms-contact-icon">
                    <i class="bx bx-help-circle"></i>
                </div>

                <div class="terms-contact-content">

                    <span>
                        Have Questions?
                    </span>

                    <h3>
                        We're happy to help.
                    </h3>

                    <p>
                        If you have any questions regarding these Terms &
                        Conditions or SolarCiti services, please contact
                        our team.
                    </p>

                    <a href="mailto:YOUR_EMAIL@example.com">
                        YOUR_EMAIL@example.com
                    </a>

                </div>

            </div>

        </div>

    </div>
</section>
<!-- End Terms & Conditions Area -->